export default "__VITE_ASSET__CsI$j82G__"